<ng-container *ngIf="isRefreshing">
  [refreshing....]
</ng-container>
<ng-container *ngIf="!isRefreshing">

  <div class="h4 secondary-text text-truncate IR-label">

    <span (click)="displayDetail = !displayDetail">
      <ng-container *ngIf="displayDetail">[-]</ng-container>
      <ng-container *ngIf="!displayDetail">[+]</ng-container>
    </span>
    Incidence Rate: {{localData.stats.incidenceRate * 100 | number}}%

  </div>

  <div class="w-100-p" style="overflow: auto;" *ngIf="displayDetail">
    <h4>{{'Détails: '|translate}}</h4>
    <pre>{{localData|json}}</pre>
  </div>

</ng-container>

